module.exports = __webpack_public_path__ + "images/4c9b97bad3224bcad1bf82ad9e5b9725.png";